/* eslint-disable jsdoc/require-description-complete-sentence */
/* eslint-disable curly */
import { isArray } from 'lodash';
const getState = (state) => state['features/user-manage'];
export const getFunctions = (state) => getState(state)?.functions;
export const getLimitUsers = (state) => state['features/base/conference']?.roomInfo?.limit_users_room;
export const checkHaveFunctionCode = (state, func) => {
    return checkFunctionHaveCode(getFunctions(state), func);
};
export const getFunctionValue = (state, func, def = undefined) => {
    return getFunctionValueInFunction(getFunctions(state), func, def);
};
/**
 * Kiểm tra tính năng có được phép hoặc tính thoả mãn của giá trị.
 *
 * @param {Array} functions - Danh sách tính năng.
 * @param {Object} func - Tính năng kiểm tra.
 * @returns {boolean} Giá trị hợp lệ.
 */
export const checkFunctionHaveCode = (functions, func) => {
    // Kiểm tra giá trị functions có hợp lệ hay không
    if (!isArray(functions))
        return false;
    // Kiểm tra tính năng có trong danh sách tính năng được cho phép hay không
    const functionValue = functions.find(f => f?.code === func?.code);
    // Trả về false nếu không có giá trị code nào có trong functions
    if (!functionValue)
        return false;
    // Kiểm tra giá trị tính năng:
    /**
     * 1. Trường hợp kiểu dữ liệu là BOOLEAN - data_type: 0
     * - Giá trị: value: "1": TRUE -> Được phép thực hiện
     * - Giá trị: value: "0": FALSE -> Không được phép thực hiện
     * 2. Trường hợp kiểu dữ liệu là STRING:
     */
    if (functionValue?.data_type !== 0)
        return Boolean(functionValue?.value);
    if (functionValue?.value === 'TRUE' || functionValue?.value === '1')
        return true;
    return false;
};
export const getFunctionValueInFunction = (functions, func, def = undefined) => {
    // Kiểm tra giá trị functions có hợp lệ hay không
    if (!isArray(functions))
        return undefined;
    // Kiểm tra tính năng có trong danh sách tính năng được cho phép hay không
    const functionValue = functions.find(f => f?.code === func?.code);
    // Trả về false nếu không có giá trị code nào có trong functions
    if (!functionValue)
        return undefined;
    // Kiểm tra giá trị tính năng:
    /**
     * 1. Trường hợp kiểu dữ liệu là BOOLEAN - data_type: 0
     * - Giá trị: value: "1": TRUE -> Được phép thực hiện
     * - Giá trị: value: "0": FALSE -> Không được phép thực hiện
     * 2. Trường hợp kiểu dữ liệu là STRING:
     */
    if (functionValue?.data_type !== 0)
        return functionValue?.value;
    if (functionValue?.value === 'TRUE' || functionValue?.value === '1')
        return true;
    return false;
};
export const checkLimitedFunction = (functions, func, currentValue) => {
    try {
        // eslint-disable-next-line max-len
        const limit = checkFunctionHaveCode(functions, func);
        // eslint-disable-next-line curly
        if (!Number.isInteger(Number(limit)))
            return true;
        return Number(limit) > Number(currentValue);
    }
    catch (error) {
        return true;
    }
};
